export default __webpack_public_path__ + "static/media/Lydia Voice.503a9226.png";